import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Pipe({ name: 'filesize' })
export class FileSizePipe implements PipeTransform {

    constructor(private translateService: TranslateService) {

    }

    transform(value: number): string {

        if(value < 1024){
            return value.toFixed() + " " + this.translateService.instant('global.B');
        }

        value = value/1024;
        if(value < 1024){
            return value.toFixed() + " " + this.translateService.instant('global.KB');
        }

        value = value/1024;

        return value.toFixed() + " " + this.translateService.instant('global.MB');
    }
}